import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-redo",
  "use": "rt-base-redo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-redo\"><path d=\"M130.4 400v424c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16V400c0-65.1 25.4-126.4 71.5-172.5 45.8-45.9 107.7-71.5 172.5-71.5 65.1 0 126.4 25.4 172.5 71.5 46.1 46.1 71.5 107.3 71.5 172.5v311.3H566.3c-6.1 0.8-9.2 8.2-5 13.1L702 928.8c12.8 15 36 15 48.8 0l140.7-204.4c4.4-5.2 0.7-13.2-6.1-13.2h-123V400c0-84.4-32.9-163.7-92.6-223.4C610.5 117.3 530.1 84 446.3 84c-84.4 0-163.8 32.9-223.4 92.6-59.7 59.6-92.6 139-92.5 223.4z\" p-id=\"3915\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/redo.svg
// module id = 1740
// module chunks = 228